"use strict";
/** state: Final **/
/** family: FileUploader **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var react_dropzone_1 = require("react-dropzone");
var Backdrop_1 = require("../Backdrop");
var CLASS_NAME = 'i-file-uploader';
/**
 * FileUploader provides a drag-and-drop receptive area for users to upload files.
 * It gives visual feedback and a callback returning an array of File objects.
 *
 * Consumers are expected to handle the actual upload of these files using the File API.
 *
 * Also see {{FileUploader#FileUploadButton}} and {{FileUploader#FileUploadList}}.
 */
var FileUploader = /** @class */ (function (_super) {
    __extends(FileUploader, _super);
    function FileUploader(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Used to programmatically open file select dialog.
         * This is intended to be used from the onClick of a fileUploadButton subcomponent
         */
        _this.openFileDialog = function () { return _this.dropzoneRef.open(); };
        _this.state = { isDragging: false };
        return _this;
    }
    FileUploader.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, ariaLabel = _b.ariaLabel, children = _b.children, className = _b.className, inputProps = _b.inputProps, isInline = _b.isInline, onDragEnter = _b.onDragEnter, onDragLeave = _b.onDragLeave, onFilesSelected = _b.onFilesSelected, restProps = __rest(_b, ["ariaLabel", "children", "className", "inputProps", "isInline", "onDragEnter", "onDragLeave", "onFilesSelected"]);
        return (React.createElement(react_dropzone_1.default, __assign({ inputProps: __assign({}, inputProps, { 'aria-label': ariaLabel }), name: CLASS_NAME + "__input", onDrop: function (acceptedFiles, rejectedFiles) {
                _this.setState({ isDragging: false });
                onFilesSelected(acceptedFiles, rejectedFiles);
            }, className: classNames(CLASS_NAME, className, (_a = {},
                _a[CLASS_NAME + "--inline"] = isInline,
                _a)), activeClassName: CLASS_NAME + "--drag-active", ref: function (node) {
                _this.dropzoneRef = node;
            }, onDragEnter: function (event) {
                _this.setState({ isDragging: true });
                onDragEnter && onDragEnter(event);
            }, onDragLeave: function (event) {
                _this.setState({ isDragging: false });
                onDragLeave && onDragLeave(event);
            } }, restProps),
            children,
            React.createElement(Backdrop_1.Backdrop, { className: CLASS_NAME + "__dragging-backdrop", active: this.state.isDragging, isTinted: true })));
    };
    // disableClick prevents a click inside the dropzone from opening the file dialog
    // The default expected use includes a FileUploadButton to open this dialog
    FileUploader.defaultProps = {
        disableClick: true,
        disablePreview: true,
    };
    return FileUploader;
}(React.Component));
exports.FileUploader = FileUploader;
//# sourceMappingURL=FileUploader.js.map